import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import baoRouter from "./../../services/bao-router";
import "./../../bindings/filtering";
function TaskModuleViewModel(parent) {
    var self = this;
    self.Bao = Bao;
    self.parent = parent;
    self.IsLoading = ko.observable(false);
    self.Initialized = ko.observable(false);
    self.CurrentTasksCollection = ko.observableArray([]);
    self.SelectedCurrentTaskRow = ko.observable({});
    self.CurrentTasksSorting = ko.observableArray();
    self.CurrentTasksSorting.subscribe(function () {
        if (self.Initialized()) {
            self.LoadTasks();
        }
    });
    self.CustomFilter = ko.observable({});
    self.CustomFilter.subscribe(function () {
        if (self.Initialized()) {
            self.LoadTasks();
        }
    });
    self.CurrentTasksTotalRows = ko.observable(0);
    self.CurrentTasksPageSize = ko.observable(10);
    self.CurrentTasksPageSize.subscribe(function () {
        if (self.Initialized()) {
            self.CurrentTasksPageIndex(0);
            self.LoadTasks();
        }
    });
    self.CurrentTasksPageIndex = ko.observable(0);
    self.CurrentTasksPageIndex.subscribe(function () {
        if (self.Initialized()) {
            self.LoadTasks();
        }
    });
    self.ToHashObject = function (customFilter) {
        var returnValue = [];
        for (var f in customFilter) {
            returnValue.push({
                Key: f,
                Value: ko.unwrap(customFilter[f])
            });
        }
        return returnValue;
    };
    self.linkTask = function (index, instructionModel) {
        var linkHash = "task/" + instructionModel.InstructionId;
        baoRouter.setHash(linkHash);
    };
    self.LoadTasks = function () {
        self.IsLoading(true);
        var customFilter = self.ToHashObject(ko.unwrap(self.CustomFilter));
        return Bao.post("Start/GetCurrentTasks", JSON.stringify({
            date: parent.ValidDateJs(),
            pageIndex: self.CurrentTasksPageIndex(),
            pageSize: self.CurrentTasksPageSize(),
            sorting: self.CurrentTasksSorting(),
            customfilter: customFilter
        }), function (searchResult) {
            self.SelectedCurrentTaskRow(null);
            self.CurrentTasksTotalRows(0);
            self.CurrentTasksCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.CurrentTasksCollection(searchResult.Models);
                self.CurrentTasksTotalRows(searchResult.TotalRows);
            }
            self.IsLoading(false);
        });
    };
    self.parent.Refresh = function () {
        self.LoadTasks();
    };
    self.loaded = function () {
        var def = $.Deferred();
        self.IsLoading(false);
        Bao.bindEvent("tasks:refresh", function (value) {
            self.LoadTasks();
        });
        $.when(self.LoadTasks()).done(function () {
            self.Initialized(true);
            def.resolve();
        });
        return def;
    };
}
export default TaskModuleViewModel;